import clsx from 'clsx';
import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { ProjectMedia, ProjectMediaLayout, ProjectMediaType } from '@interfaces/projects';
import { getImgixSrc } from '@utils/images';

interface MediaProps {
  media: ProjectMedia;
  mediaSourcePath: string;
}

const Media = ({ media, mediaSourcePath }: MediaProps) => {
  return (
    <div
      className={clsx('w-full flex-grow md:w-5/12', {
        'basis-full': media.layout == ProjectMediaLayout.FullWidth,
      })}
    >
      {media.mediaType == ProjectMediaType.Iframe && (
        // TODO: https://app.asana.com/0/1201413338509198/1208215348589827/f
        // Utilize order and support multiple iframes.
        // Also, do we actually need media.style? can maybe drop this field
        <iframe
          aria-label="Chart"
          className="min-w-full overflow-hidden border-none"
          data-external="1"
          height={media.height}
          id={media.elementId}
          src={media.src}
          title={media.title}
          scrolling="no" // scrolling is deprecated, but necessary in chrome... see -> https://github.com/davidjbradshaw/iframe-resizer/issues/1142#issuecomment-1959544213
        ></iframe>
      )}
      {/* TODO: Below is placeholder logic, we currently only support 1 iframe graphic */}
      {media.mediaType == ProjectMediaType.Image && (
        <LazyImgixImage
          alt={media.title}
          src={getImgixSrc({
            path: `${mediaSourcePath}/${media.src}`,
            isEnvDependent: false,
          })}
        />
      )}
    </div>
  );
};

export default Media;
